"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewMoreCard = void 0;
var React = require("react");
var prm_1 = require("utils/prm");
var lang_1 = require("../../../../../utils/lang");
var styles_1 = require("./styles");
exports.ViewMoreCard = function (props) {
    var isRollOver = props.isRollOver, link = props.link, params = props.params;
    var getCardType = function () {
        return isRollOver ? styles_1.CardType.LTRoll : styles_1.CardType.LTDouble;
    };
    return (React.createElement(styles_1.VMCardBoxWrapper, { cardType: getCardType() },
        React.createElement(styles_1.VMCardBox, { cardType: getCardType(), onClick: function () { return prm_1.genPrmLink(link, __assign(__assign({}, params), { position: 0 })); } },
            React.createElement(styles_1.FlexWrapper, null,
                React.createElement("div", null,
                    React.createElement("img", { style: { width: 32, height: 32 }, src: "https://i.ezbuy.sg/FjFwuX0r1Lw5Z4nb3BfR2uPt3zVY" })),
                React.createElement(styles_1.TextSpan, null, lang_1.getLitbLangFn()("View More"))))));
};
exports.default = exports.ViewMoreCard;
